import React from "react";
import {observer} from "mobx-react";
import {
    BottomNavigationBarMenuItemIconBox
} from "./boxes/menu-item-icon/bottom-navigation-bar-menu-item-icon.box";
import {ISvgIconProps} from "../../basic-ui-components/icon/svg-icon/svg.icon";
import {useServices} from "../../react-hooks/use-services.hook";
import {IMenuItemRenderer} from "../../services/menu-items-common/renderer/menu-item.renderer.interface";
import {CyClass} from "../../../common/cy-classes";

interface BottomNavigationBarMenuItemIconComponentProps {
    menuItem: IMenuItemRenderer;
    isActive: boolean;
}

export const BottomNavigationBarMenuItemIconComponent: React.FC<BottomNavigationBarMenuItemIconComponentProps> = observer((props) => {
    const services = useServices();

    if(props.menuItem.iconSource !== "themeIcons" || !props.menuItem.icon) {
        return null;
    }

    const InternalNavIcon: React.ComponentType<ISvgIconProps> | undefined = services.theme.currentTheme.icons[props.menuItem.icon];

    if(!InternalNavIcon) {
        return null;
    }

    return (
        <BottomNavigationBarMenuItemIconBox isActive={props.isActive} className={CyClass('cy-bottom-navbar-menu-icon')}>
            {InternalNavIcon ? <InternalNavIcon size={2.4} title={props.menuItem.iconAltText ?? '' } /> : null}
        </BottomNavigationBarMenuItemIconBox>
    );
});